// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"c72d2fd3","453":"bfd56f49","958":"4041cd9b"}[chunkId] + ".chunk.js";
};